import axios from 'axios';
import config from "../../config/index.js";
import common from "../units/common.js";

var host = null;
if (process.env.NODE_ENV == 'development') {
  host = 'http://localhost:6087/';
  //host = 'http://192.168.168.201:9806/api/';
  //host = 'https://www.xjdread.com/userapi/';

} else {
  if (window.location.host.indexOf('192.168.168.201') > -1) {
    host = 'http://192.168.168.201:9806/api/';
  } else if (window.location.host.indexOf('read.booksfor.net') > -1) {
    host = 'http://read.booksfor.net:9806/api/';
  } else {
    host = 'https://www.xjdread.com/userapi/';
  }
  //本地部署适配
  // host = window.location.origin + '/userapi/';
}
axios.defaults.baseURL = host;

axios.interceptors.request.use((config) => {
  return config;
}, (error) => {
  return Promise.reject(error);
});
axios.interceptors.response.use((res) => {
  // 临近过期，刷新token
  if (res.headers.etime < 1) {
    common.loading.open("刷新凭证");
    api.RefreshToken().then((res) => {
      common.loading.close();
      if (res.code == 1) {
        common.token.set(res.token)
      }
    });
  }
  if (res.data.code > -31 && res.data.code < -20) {
    return;
  }
  return Promise.resolve(res);
}, (error) => {
  return Promise.reject(error.response);
});
function postJson(url, params, loading, config) {
  let token = common.token.get();
  if (token)
    axios.defaults.headers[common.token.authorize] = common.token.get();
  return new Promise((resolve, reject) => {
    axios.post(url, params, config).then(response => {
      resolve(response.data);
    }, err => {
      reject(err && err.data && err.data.message ? err.data.message : '服务器处理异常');
    }).catch((error) => {
      reject(error)
    })
  })
}
function postForm(url, params, loading, config) {
  let headers = {};
  if (common.token.get()) {
    headers = common.token.headers();
  }
  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: url,
      params,
      headers: headers
    }).then(response => {
      resolve(response.data);
    }, err => {
      reject(err && err.data && err.data.message ? err.data.message : '服务器处理异常');
    }).catch((error) => {
      reject(error)
    })
  })
}
function upload(url, params) {
  if (!params) {
    return common.message.error("未找到参数");
  }
  if (!params.file) {
    return common.message.error("未找到文件");
  }
  var data = new FormData();
  data.append('file', params.file);
  var config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };
  if (params.path) {
    url = url + "?path=" + params.path;
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data, config).then(res => {
      if (res.data.code != 1) {
        return common.message.error(res.info);
      }
      resolve(res.data);
    }).catch(error => {
      reject(error);
    });
  })
}
function reWriteApi(url, methods) {
  if (!methods) {
    methods = "form";
  }
  return function (params, mode) {
    if (mode) {
      return axios.defaults.baseURL + url;
    }
    if (methods.toLowerCase() == "upload") {
      return upload(url, params);
    }
    if (methods.toLowerCase() == "json") {
      return postJson(url, params);
    }
    return postForm(url, params);
  }
}
function getImg(src) {
  if (!src) {
    return;
  }
  return common.getImg(src, axios.defaults.baseURL);
  //return common.getImgSrc(src, "http://read.booksfor.net:5821/");
}
function local(src) {
  var assets = config.path.assets;
  var result = (assets + src).replaceAll("//", "/");
  return result;
}
function cloud(src) {

}

let api = {
  Register: reWriteApi('Login/Register', "Json"),
  Login: reWriteApi('Login/Login', "Json"),
  CarsiLogin: reWriteApi('carsi/Login'),
  RefreshToken: reWriteApi('Login/Refresh', 'Json'),
  GetAgencyUrl: reWriteApi('Login/GetAgencyUrl'),

  AddWorkVideoLog: reWriteApi('Log/AddWorkVideoLog'),




  GetNavList: reWriteApi('Nav/GetNavList'),
  GetHomeMenuList: reWriteApi('HomeMenu/GetHomeMenuList'),
  GetHomeMenuBookList: reWriteApi('Public/GetHomeMenuBookList'),
  GetModuleList: reWriteApi('Public/GetModuleList'),
  GetBannerList: reWriteApi('Public/GetBannerList'),
  GetPackageServerList: reWriteApi('Public/GetPackageServerList'),
  GetPackageTree: reWriteApi('Public/GetPackageTree'),
  GetPackageMenuList: reWriteApi('Public/GetPackageMenuList'),

  GetUploadList: reWriteApi('Public/GetUploadList'),
  GetClassicsList: reWriteApi('Classics/GetClassicsList', 'Form'),
  GetClassicsAuthorBookPage: reWriteApi('Classics/GetClassicsAuthorBookPage', "Json"),
  GetClassicsBookPage: reWriteApi('Classics/GetClassicsBookPage', "Json"),





  // Book
  GetBookPage: reWriteApi('Book/GetBookPage', 'Json'),
  GetModuleBookPage: reWriteApi('Book/GetModuleBookPage', 'Json'),
  GetResourceBookPage: reWriteApi('Book/GetResourceBookPage', 'Json'),



  GetPackageInfo: reWriteApi('Public/GetPackageInfo'),
  GetPackageSheetList: reWriteApi('Sheet/GetPackageSheetList'),

  GetPodcastList: reWriteApi('Book/GetPodcastList'),
  GetPodcastTimeline: reWriteApi('Book/GetPodcastTimeline'),
  AddPodcastViewCount: reWriteApi('Book/AddPodcastViewCount'),
  AddPodcastPlayDuration: reWriteApi('Book/AddPodcastPlayDuration'),


  GetRankPackageList: reWriteApi('Book/GetRankPackageList'),
  GetRankBookPage: reWriteApi('Book/GetRankBookPage', 'Json'),

  GetCataloguePage: reWriteApi('Book/GetBookCatalogPage', "Json"),
  GetSoundBookChildList: reWriteApi('Book/GetSoundBookChildList'),
  ReadBook: reWriteApi('Book/ReadBook', "Json"),

  GetModuleData: reWriteApi('Module/GetModuleData', 'Form'),




  // Activity
  GetSchoolActivityList: reWriteApi('Activity/GetSchoolActivityList'),
  GetMemberActivityList: reWriteApi('Activity/GetMemberActivityList'),

  GetActivityInfo: reWriteApi('Activity/GetActivityInfo'),
  GetActivityDetail: reWriteApi('Activity/GetActivityDetail'),
  GetActivityUrl: reWriteApi('Activity/GetUrl'),
  GetEnrollInfo: reWriteApi('Activity/GetEnrollInfo'),
  EnrollActivity: reWriteApi('Activity/Enroll', 'Json'),




  // AI
  CreateConversation: reWriteApi('AI/CreateConversation', 'Form'),//创建会话
  ChartConversation: reWriteApi('AI/ChartConversation', "Json"),//发起对话
  ChartRetrieve: reWriteApi('AI/ChartRetrieve', "Json"),//轮询
  ChartMessageList: reWriteApi('AI/ChartMessageList', "Json"),//获取回答
  ChartFlow: reWriteApi('AI/ChartFlow', "Json"),//发起对话 对话流
  GetBookVideoList: reWriteApi('Book/GetBookVideoList', 'Form'),
  SendAiSession: reWriteApi('AI/SendAiSession', 'Form'),
  GetUserAiSessionView: reWriteApi('AI/GetUserAiSessionView', "Json"),
  GetUserAiChatView: reWriteApi('AI/GetUserAiChatView', "Json"),
  CallWorkflowAsyncExt: reWriteApi('AI/CallWorkflowAsyncExt', "Json"),
  GetWorkflowResult: reWriteApi('AI/GetWorkflowResult', 'Form'),
  AudioToText: reWriteApi('AI/AudioToText', 'Upload'),
  GetAiDomain: reWriteApi('AI/GetAiDomain', 'Form'),
  GetAiSearKeyWord: reWriteApi('AI/GetAiSearKeyWord', 'Form'),
  GetSynopsis: reWriteApi('AI/GetSynopsis', 'Form'),
  GetMindMap: reWriteApi('AI/GetMindMap', 'Form'),
  GetVideo: reWriteApi('AI/GetVideo', 'Form'),

  GetCommentPage: reWriteApi('Comment/GetCommentPage', 'Json'),
  SubmitComment: reWriteApi('Comment/SubmitComment', 'Json'),
  RemoveComment: reWriteApi('Comment/RemoveComment'),
  SubmitPraise: reWriteApi('Comment/SubmitPraise'),
  GetReplyPage: reWriteApi('Comment/GetReplyPage', 'Json'),
  SubmitReply: reWriteApi('Comment/SubmitReply', 'Json'),
  RemoveReply: reWriteApi('Comment/RemoveReply'),


  SubmitLike: reWriteApi('Like/SubmitLike'),


  // region HuaWeiCloud
  GetHuaWeiCloudAddress: reWriteApi('HuaWeiCloud/GetAddress'),
  AddHuaWeiCloud: reWriteApi('HuaWeiCloud/Insert'),
  DelHuaWeiCloud: reWriteApi('HuaWeiCloud/Delete'),
  // endregion

  GetWorkPage: reWriteApi('Work/GetWorkPage', 'Json'),
  GetWorkPlayerPage: reWriteApi('Work/GetWorkPlayerPage', 'Json'),
  GetWorkCenterPage: reWriteApi('Work/GetWorkCenterPage', 'Json'),

  GetWorkDetailInfo: reWriteApi('Work/GetDetailInfo'),
  GetWorkModifyInfo: reWriteApi('Work/GetModifyInfo'),
  GetWorkInfo: reWriteApi('Work/GetWorkInfo'),
  SubmitWork: reWriteApi('Work/Submit', 'Json'),
  RemoveWork: reWriteApi('Work/Remove'),

  GetActivityModifyInfo: reWriteApi('Work/GetActivityModifyInfo'),


  GetWorkTagList: reWriteApi('Work/GetWorkTagList'),
  GetActivityList: reWriteApi('Work/GetActivityList'),
  GetLiveTagList: reWriteApi('Work/GetTagList'),
  GetSelectTagList: reWriteApi('Work/GetSelectTagList'),





  SubmitCollect: reWriteApi('Collect/SubmitCollect', 'Form'),
  RemoveCollect: reWriteApi('Collect/RemoveCollect', "Json"),
  MoveCollect: reWriteApi('Collect/Move', "Json"),

  SubmitFolder: reWriteApi('Folder/Submit', "Json"),
  RemoveFolder: reWriteApi('Folder/Remove', 'Form'),




  UploadFile: reWriteApi('Upload/UploadFile', 'upload'),
  GetCategoryBroadList: reWriteApi('Book/GetCategoryBroadList'),


  GetBookReviewWorkflow: reWriteApi('AI/GetBookReviewWorkflow'),
  GetBookReviewResult: reWriteApi('AI/GetBookReviewResult'),



  GetActivityPoster: reWriteApi('Invite/GetActivityPoster'),

  match: reWriteApi('Login/Match'),
  decode: reWriteApi('Login/DecodeGzh'),

  matchOrg: reWriteApi('Center/MatchOrg'),


  QuickAgency: reWriteApi('Center/QuickAgency'),

  GetReadUrl: reWriteApi('Book/GetReadUrl'),
  VerifyBookAuth: reWriteApi('Book/Verify'),

  GetBookInfo: reWriteApi('Book/GetBookInfo'),
  GetBookDetail: reWriteApi('Book/GetBookDetail'),
  GetNextPlayPodcastId: reWriteApi('Book/GetNextPlayPodcastId', 'Json'),

  AddPurchaseRecord: reWriteApi('Book/AddPurchaseRecord', 'Form'),
  GetHuiCaiUrl: reWriteApi('Book/GetHuiCaiUrl'),

  ReadyBook: reWriteApi('BorrowReturn/readyMobileBook', "Json"),
  BorrowReturnList: reWriteApi('BorrowReturn/Mobilelist', "Json"),
  returnBookAll: reWriteApi('BorrowReturn/returnBookAll', "Json"),


  GetSchoolList: reWriteApi('Public/GetSchoolList', 'Form'),


  // sheet
  GetSheetBookPage: reWriteApi('Belong/GetSheetBookPage', 'Json'),
  GetSheetTagList: reWriteApi('Sheet/GetSheetTagList'),
  GetSheetPage: reWriteApi('Sheet/GetSheetPage', 'Json'),
  GetSheetCenterPage: reWriteApi('Sheet/GetSheetCenterPage', 'Json'),
  GetSheetCollectPage: reWriteApi('Sheet/GetSheetCollectPage', 'Json'),

  GetSheetDetail: reWriteApi('Sheet/GetSheetDetail'),
  GetSheetModifyInfo: reWriteApi('Sheet/GetModifyInfo'),

  GetSheetInfo: reWriteApi('Sheet/GetSheetInfo'),


  SubmitSheet: reWriteApi('Sheet/Submit', 'Json'),
  RemoveSheet: reWriteApi('Sheet/Remove'),


  GetMember: reWriteApi('Center/GetMember'),
  GetMemberRelatedList: reWriteApi('Center/GetMemberRelatedList'),
  UpdateMember: reWriteApi('Center/UpdateMember', "Json"),
  UpdateTel: reWriteApi('Center/UpdateTel'),
  UpdatePhoto: reWriteApi('Center/UpdatePhoto'),
  UpdatePassword: reWriteApi('Center/UpdatePassword'),
  Logout: reWriteApi('Center/Logout'),

  SendSms: reWriteApi('Sms/SendSms'),
  CheckSms: reWriteApi('Sms/CheckSms'),

  GetReadData: reWriteApi('Center/GetReadData'),

  GetCollectResult: reWriteApi('Collect/GetCollectResult', "Json"),


  GetHistoryTotalPage: reWriteApi('Center/GetHistoryTotalPage'),
  RemoveHistory: reWriteApi('Center/RemoveHistory', "Json"),

  // school/course
  GetCourseEnrollPage: reWriteApi('SchoolCourse/GetCourseEnrollPage', 'Json'),
  GetCourseCenterPage: reWriteApi('SchoolCourse/GetCourseCenterPage', 'Json'),

  GetTeamDetail: reWriteApi('SchoolCourse/GetTeamDetail'),
  GetTaskDetail: reWriteApi('SchoolCourse/GetTaskDetail'),

  GetSchoolEnrollInfo: reWriteApi('SchoolCourse/GetEnrollInfo'),
  EnrollSchoolTeam: reWriteApi('SchoolCourse/EnrollTeam'),
  SubmitSchoolWork: reWriteApi('SchoolCourse/SubmitWork', 'Json'),
  RemoveSchoolWork: reWriteApi('SchoolCourse/RemoveWork'),

  // school/game
  GetGamePoster: reWriteApi('SchoolGame/GetGamePoster'),
  SearchGameMemberReadData: reWriteApi('SchoolGame/SearchGameMemberReadData'),
  SubmitGameMemberReadData: reWriteApi('SchoolGame/SubmitGameMemberReadData'),

  GetHotSearchBookList: reWriteApi('Search/GetHotSearchBookList'),
  GetLikeSearchBookList: reWriteApi('Search/GetLikeSearchBookList'),

  GetBelongWorkVideoList: reWriteApi('Belong/GetBelongWorkVideoList'),
  GetBelongWorkPodcastList: reWriteApi('Belong/GetBelongWorkPodcastList'),

  GetInviteBookDetail: reWriteApi('Invite/GetInviteBookDetail'),
  GetInviteBookPoster: reWriteApi('Invite/GetInviteBookPoster'),
  SetInviteBookExtend: reWriteApi('Invite/SetInviteBookExtend', 'Json'),

  GetPlanInviteCode: reWriteApi('SchoolPlan/GetPlanInviteCode'),
  GetPlanReadBookList: reWriteApi('SchoolPlan/GetPlanReadBookList'),

}
export default { ajax: axios, api, getImg, postJson, postForm, upload, local, cloud, host: host }



// WEBPACK FOOTER //
// ./src/api/http.js